
export const useShouldShowSwitchMFWOriginals = ({ option, isClient, isSuperAdmin, isAnotherOrgOnMFWPlatform, isWhiteLabel, hasMfwContent }: {
  option: boolean,
  isClient: boolean,
  isSuperAdmin: boolean,
  isAnotherOrgOnMFWPlatform: boolean,
  isWhiteLabel: boolean,
  hasMfwContent: boolean,
}): boolean => {


  // BEFORE:
  // (organizationId !== process.env.REACT_APP_MFW_ORGANIZATION_ID && !isWhiteLabel) || (isWhiteLabel && mfwTheme.theme.whitelabel.haveMFWContent))
  // &&  userContext.user &&  userRole !== Role.SuperAdmin && !isClient 

// Ja msm da nama ovo ne treba uopste jer klijent samo vidi marketplace gde nema ovog switcha...? Superadmin je iskljucen jer je mfw org na mfw platformi iskljucena.. 
  const userPermission = !isSuperAdmin;
  const orgPermission = isAnotherOrgOnMFWPlatform || (isWhiteLabel && hasMfwContent);

  const result = option && userPermission && orgPermission;
  return result;
};
